export default {"src":"/_next/static/media/certifiedAqua.8654899c.svg","height":15,"width":15};